module.exports = __webpack_public_path__ + "img/4_izbove.f5cce8d4.jpg";